<template>
  <div class="myContianer">
    <div class="title">
      <h1 style="color:#666;">我的组件库</h1>
    </div>
    <div class="box">
      <div><h3>自定义省市级联组件</h3></div>
      <my-cascader></my-cascader>
    </div>
    <div class="box">
      <div><h3>自定义右键弹框菜单</h3></div>
      <context-menu></context-menu>
    </div>
  </div>
</template>
<script>
import { cityOptions } from '@/utils/enumeration.js'
export default {
  name:'demo',
  components:{
    'MyCascader':()=>import('@/components/MyCascader.vue'),
    'ContextMenu':()=>import('@/components/ContextMenu.vue')
  },
  created(){
    this.provinceList = cityOptions
    console.log(cityOptions)
  },
  data(){
    return {
      provinceList:null,
      cityList:null,
      countyList:null,
      province:'',
      city:'',
      county:''
    }
  },
  methods: {

  },
};
</script>
<style lang="less" scoped>
  .title{
    width: 100%;
    height: 50px;
    line-height: 50px;
    margin-top:20px;
  }
  .box{
    width: 500px;
    height: 300px;
    border:1px solid #ccc;
    border-radius: 5px;
    margin:20px 50px;
    text-align: left;
    padding:20px;
    box-sizing: border-box;
  }
</style>